import { render, staticRenderFns } from "./form_primeira_etapa.vue?vue&type=template&id=5d566b3c"
import script from "./form_primeira_etapa.vue?vue&type=script&lang=js"
export * from "./form_primeira_etapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports